import { ErrorMessage, Field, useFormikContext } from "formik";
import MultiSelect from "multiselect-react-dropdown";
import React, { useCallback, useEffect, useRef, useState } from "react";
import TextError from "../TextError";

import { Typography } from "@mui/material";
import CustomeMultiSelect from "./CustomeMultiSelect";

const FormikMultiSelect = (props) => {
  const {
    label,
    name,
    validation,
    readOnly,
    productName,
    options,
    errors,
    quickQuoteDetails,
    ...rest
  } = props;
  const [customeOptions, setCustomeOptions] = useState();
  const [addOnValues, setAddOnValues] = useState();
  const multiselectRef = useRef(null);
  //let customeOptions = options
  //console.log('multi name',name,options)

  let tryGroupOptions=[
     
{value: 'SMART', label: 'SMART'},
{value: 'CAREWITHNCB', label: 'NCB-Super'},
{value: 'OPDCARE-5000', label: 'OPDCARE-5000',cat:'OPD(select only one)'},
{value: 'OPDCARE-10000', label: 'OPDCARE-10000',cat:'OPD'},
{value: 'OPDCARE-15000', label: 'OPDCARE-15000',cat:'OPD'},
{value: 'OPDCARE-20000', label: 'OPDCARE-20000',cat:'OPD'},

{value: 'COPAYWAIVER1103', label: 'Co-Payment waiver'},
{value: 'CARESHILED1104', label: 'Care Shield'}
  ]

  const formContext = useFormikContext();
  useEffect(() => {
    if (formContext.values.dependentDetail.addOns !== undefined) {
      if (quickQuoteDetails.Acuvisor_product_id === 33111) {
        console.log(
          "addOn",
          formContext.values.dependentDetail.addOns,
          options
        );

        if (
          formContext.values.dependentDetail.addOns.indexOf("CAREWITHNCB") != -1
        ) {
          console.log("yees");
          setCustomeOptions(options);
        } else {
          console.log("nnnnoo");
          if (
            formContext.values.dependentDetail.addOns.indexOf(
              "REDPEDWAITPRD"
            ) != -1
          ) {
            // formContext.setFieldValue('addOns',formContext.values.dependentDetail.addOns.replace("REDPEDWAITPRD",""))
          }
          setCustomeOptions(
            options.filter((item) => item.value != "REDPEDWAITPRD")
          );
        }
      }else if (quickQuoteDetails.Acuvisor_product_id === 33222) {
        setCustomeOptions(options)
      }else if (quickQuoteDetails.Acuvisor_product_id === 33333) {
        setCustomeOptions(options)
      }

    }
  }, [formContext]);

  const onSelect = useCallback(
    (val, ele,setFieldValue) => {
      console.log("multi val", val,ele);
      let recVal = Array.isArray(val) ? val.map((e) => e.value) : [];
      let recLabel = Array.isArray(val) ? val.map((e) => e.label) : [];
     

      /* This is checking if the selected value is an array and if the array has more than one item with
     the category of OPD. If it does, it removes the item from the list. */
     let isOpdSelected = Array.isArray(val) ? val.filter((obj)=> obj.cat === "OPD (Select only one option)").length > 1 : true;
     console.log("isOpdSelected: ",isOpdSelected)
     if(isOpdSelected && ele?.cat === "OPD (Select only one option)"){
       multiselectRef.current.onRemoveSelectedItem(ele);
       alert("Only One Item Can be Selected from OPD")
     }

      /* if (recLabel.join() === 'NCB-Super') {
            console.log('jjj', customeOptions)
            setCustomeOptions(options)


        } else {
            console.log('jjj', customeOptions)
            let gg = customeOptions.filter(item => item.label != "Reduction in PED")
            console.log('filt', gg)
            setCustomeOptions(gg)

        } */
      setFieldValue(name, recVal.join());
    },
    [customeOptions]
  );

  return (
    <div>
      <Typography>{label}</Typography>

      <Field name={name}>
        {({ form, field }) => {
          const { setFieldValue, values } = form;
          let selectedvalue = [];
          const date = values["dependentDetail"]["birthDt"];
          const getAge = Math.floor(
            (new Date() - new Date(date).getTime()) / 3.15576e10
          );
          //const getAge =
          console.log("quickQuoteDetails", quickQuoteDetails.eldestMemberAge);

          const onRemove = (val) => {
            console.log("onRemo multi val", val);
            let recVal = Array.isArray(val) ? val.map((e) => e.value) : [];
            let recLabel = Array.isArray(val) ? val.map((e) => e.label) : [];
            console.log("onRemo receive val", recVal, recLabel.join());

            if (recVal.indexOf("CAREWITHNCB") != -1) {
            } else {
              if (recVal.indexOf("REDPEDWAITPRD") != -1) {
                recVal = recVal.filter((item) => item != "REDPEDWAITPRD");
               
                multiselectRef.current.onRemoveSelectedItem({
                  value: "REDPEDWAITPRD",
                  label: "REDUCTION In PED",
                });
              }
            }

            console.log("jjjj", recVal);
            setFieldValue(name, recVal.join());
            // console.log("MultiSelectRef:", multiselectRef.current);

            // return recVal;
          };

          if (productName !== "Tab_CareFreedom") {
            if (Number(quickQuoteDetails.eldestMemberAge) <= 35) {
              selectedvalue.push(
                { value: "CARESHILED1104", label: "Care Shield" },
                { value: "CAREWITHNCB", label: "NCB-Super" }
              );
            } else if (
              Number(quickQuoteDetails.eldestMemberAge) <= 45 &&
              Number(quickQuoteDetails.eldestMemberAge) > 35
            ) {
              selectedvalue.push({ value: "CAREWITHNCB", label: "NCB-Super" });
            } else if (Number(quickQuoteDetails.eldestMemberAge) > 45 && quickQuoteDetails.pincodeZone === "Zone 3") {
              selectedvalue.push({ value: "OPDCARE-5000", label: "OPD Care (Opd care is available only for 5000)" });
            } else {
              selectedvalue = [];
            }
          }

          return (
            <>
              {/*  <CustomeMultiSelect 
                               name={name}
                               onSelect={onSelect}
                               customeOptions={customeOptions}
                               label={label}
                               /> */}
              <MultiSelect
                name={name}
                disablePreSelectedValues
                selectedValues={selectedvalue}
                //selectedValues={values[name]}
                onKeyPressFn={(val) => onSelect(val, formContext.setFieldValue)}
                onRemove={(val) => onRemove(val, formContext.setFieldValue)}
                onSelect={(val,ele) => onSelect(val,ele, formContext.setFieldValue)}
                groupBy="cat"
                options={customeOptions}
                //options={tryGroupOptions}

                displayValue="label"
                showCheckbox
                placeholder={label}
                ref={multiselectRef}
              />
            </>
          );
        }}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default FormikMultiSelect;
